import React from 'react';

import { View } from 'react-native';

import { DETAIL_CHANNEL_LOGO_ID } from 'config/testID';

import useImageRatio from 'utils/hooks/useImageRatio';
import { isWeb } from 'utils/responsiveness';

import NagraImage from 'components/NagraImage';
import {
    AspectRatio,
    ImageContentType,
    ImageSize,
    ImageType,
} from 'components/NagraImage/types';
import { getImageUrl } from 'components/NagraImage/utils';
import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    channelId?: string;
    channelName?: string;
};

function DetailPageChannelLogo({ channelId, channelName }: Props) {
    let { height } = ImageSize.BIG_CHANNEL_LOGO;
    const imageUrl =
        channelId &&
        getImageUrl({
            aspect: AspectRatio.LANDSCAPE,
            contentId: channelId,
            contentType: ImageContentType.CHANNEL,
            imageType: ImageType.LOGO,
            height,
        });
    const { ratio: aspectRatio, imageRatioError } = useImageRatio(imageUrl);
    const ultraWideAspectRatio = 21 / 9;

    if (aspectRatio > ultraWideAspectRatio) {
        height /= ultraWideAspectRatio;
    }

    return (
        <View
            style={styles.root}
            accessibilityLabel={channelName}
            accessibilityRole="image"
            accessible
            {...(isWeb && { tabIndex: 0 })}
        >
            {!!(!imageRatioError && channelId) && (
                <NagraImage
                    style={[styles.root, { aspectRatio }]}
                    resizeMode="contain"
                    contentId={channelId}
                    imageType={ImageType.LOGO}
                    contentType={ImageContentType.CHANNEL}
                    aspect={AspectRatio.LANDSCAPE}
                    height={height}
                    testID={DETAIL_CHANNEL_LOGO_ID}
                    aria-hidden={isWeb}
                />
            )}
            {!!((imageRatioError || !channelId) && channelName) && (
                <Text
                    style={styles.text}
                    color={ETextColor.neutral}
                    category={ETextCategory.title1}
                    aria-hidden={isWeb}
                >
                    {channelName}
                </Text>
            )}
        </View>
    );
}

export default DetailPageChannelLogo;
